import React,{Component} from 'react'


export default class RDOButton extends Component {
    // if you want to render it, you must create a js snippet with the following content:
    // var enableRDOButton = true;
    // state = {
    //     showButton: window.enableRDOButton
    // }

    render() {
        // const { showButton } = this.state
        const showButton = window.enableRDOButton
        const { submitRDO } = this.props

        // if(showButton) {
        return (
            <button
                data-cy="submitRDO"
                className="btn-primary btn"
                style={{ width: 100, float: 'right', display: showButton ? 'block' : 'none' }}
                onClick={() => submitRDO()}
            >
                Upload RDO
            </button>
        )
        // }
    }
}
